/**
 * CHART ANALYTICA'S OWN PEN, declared once.
 *
 * <p>A palette is edited for appearance, by eye, one file at a time — which is how three files
 * came to hold the same `#d4a017` under three comments each claiming it was shared. The dialog,
 * the overlay and the chart branch all import from here, and a test asserts none of them holds
 * a hex of its own.
 *
 * <h2>Why these hues</h2>
 *
 * The chart already spends amber on PTA and the replay playhead, cyan on PTB, and purple on CTS.
 * Chart Analytica audits all three and must not be mistaken for any of them, so its own frame is
 * a desaturated SLATE — visible as a boundary and recessive against every study inside it.
 *
 * <p>The event marks keep the chart's existing directional pair (emerald up, crimson down),
 * because "which way did this signal point" is a question the whole application already answers
 * in those two colours and a fourth convention would be one more thing to learn.
 */

/** The frame: scope band, audit verticals, the click line. Slate, deliberately not a study hue. */
export const CHART_ANALYTICA_COLOR = '#94A3B8';

/** The scanned range, behind everything. Low enough that candles read straight through it. */
export const CHART_ANALYTICA_SCOPE_FILL = 'rgba(148, 163, 184, 0.07)';

/** The clicked bar — the one line in this study that is a statement rather than a background. */
export const CHART_ANALYTICA_CLICK = '#F8FAFC';

/** Event direction, matching the chart's own up/down pair. */
export const CHART_ANALYTICA_UP = '#10B981';
export const CHART_ANALYTICA_DOWN = '#EF4444';

/** The audit verticals, which sit under the price action and must stay under it. */
export const AUDIT_LINE_OPACITY = 0.28;
export const AUDIT_LINE_WIDTH = 1;

/**
 * The dashboard's accent: the active tab's rule, a caveat, a compared run's heading.
 *
 * <p>Amber because every CAVEAT in this panel is a warning about how a number may be misread,
 * and because it is the one hue on the glass surface that is neither of the two directional
 * colours — a caveat printed in red would read as a bad result rather than as a caution about
 * a good-looking one.
 */
export const CHART_ANALYTICA_ACCENT = '#FCD34D';
